import { create } from 'zustand'

export type PaymentMethod = 'wallet' | 'coinbase' | 'manual' | null
type PayAsset =
    | 'BTC'
    | 'ETH'
    | 'USDC'
    | 'POLYGON'
    | 'USDT-TRC20'
    | 'USDT-ERC20'
    | 'SOL'
    | null

interface OrderState {
    // Package selection
    // Package selection
    selectedPackage: {
        id: string
        name: string
        amount: number
        price: number
    } | null

    // Developer Access
    developerAccess: {
        id: string
        name: string
        price: number
        amount: number
    } | null

    // Wallet/delivery info
    walletAddress: string
    network: string

    // Additional fields
    email: string
    promoCode: string

    // UI state
    paymentMethod: PaymentMethod
    // What the user wants to PAY with (separate from delivery network)
    payAsset: PayAsset
    walletConnection: {
        connected: boolean
        address: string
        network: string
    }

    // Actions
    setSelectedPackage: (pkg: OrderState['selectedPackage']) => void
    setDeveloperAccess: (access: OrderState['developerAccess']) => void
    setWalletAddress: (address: string) => void
    setNetwork: (network: string) => void
    setEmail: (email: string) => void
    setPromoCode: (code: string) => void
    setPaymentMethod: (method: PaymentMethod) => void
    setPayAsset: (asset: PayAsset) => void
    setWalletConnection: (connected: boolean, address?: string, network?: string) => void
    resetOrder: () => void
    getTotalPrice: () => number
}

export const useOrderStore = create<OrderState>((set, get) => ({
    selectedPackage: null,
    developerAccess: null,
    walletAddress: '',
    network: 'Tron (TRC20)',
    email: '',
    promoCode: '',
    paymentMethod: null,
    payAsset: null,
    walletConnection: {
        connected: false,
        address: '',
        network: '',
    },

    setSelectedPackage: (pkg) => set({ selectedPackage: pkg }),
    setDeveloperAccess: (access) => set({ developerAccess: access }),
    setWalletAddress: (address) => set({ walletAddress: address }),
    setNetwork: (network) => set({ network }),
    setEmail: (email) => set({ email }),
    setPromoCode: (code) => set({ promoCode: code }),
    setPaymentMethod: (method) => set({ paymentMethod: method }),
    setPayAsset: (asset) => set({ payAsset: asset }),
    setWalletConnection: (connected, address, network) =>
        set({
            walletConnection: {
                connected,
                address: address ?? '',
                network: network ?? '',
            },
        }),
    resetOrder: () => set({
        selectedPackage: null,
        developerAccess: null, // Reset dev access
        walletAddress: '',
        network: 'Tron (TRC20)',
        email: '',
        promoCode: '',
        paymentMethod: null,
        payAsset: null,
        walletConnection: {
            connected: false,
            address: '',
            network: '',
        },
    }),
    getTotalPrice: () => {
        const state = get()
        const packagePrice = state.selectedPackage?.price || 0
        const devPrice = state.developerAccess?.price || 0
        return packagePrice + devPrice
    }
}))
